import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { PartialId } from '@attain-apps/string-builder'

export type TypeParams = ec.models.TypeParams.WithDefaults<{
  entity: Entity
  createEntity: CreateEntity
  context: Context
}>

export type Entity = ents.core.agent.Conversation

export type CreateEntity = ents.core.agent.Conversation.Input

export type Context = ents.core.admin.Context.ForZone | undefined
export const GLOBAL_WORKSPACE_ID = PartialId.from('global')
